import Decimal from 'decimal.js'
import { converterTable } from './config'
import { getTargetAssetName } from './helpers'
import { setLatestRatesItem } from './store/redusers/assets/actions'

export default class TradingService {
	constructor(props) {
		this.props = props
	}

	getLotCountAsset = async () => {
		const {
			soId,
			lotCountData
		} = this.props
		if (!lotCountData[soId]) {
			return new Decimal(1)
		} else {
			return new Decimal(lotCountData[soId])
		}
	}

	getDecimalNumber = async (numDigit) => {
		return (new Decimal(1)).dividedBy(Math.pow(10, numDigit))
	}

	pipValueDetailsWithOutConversion = async (lotSize, lotCount, decimalNumber) => {
		return lotSize.mul(lotCount).mul(decimalNumber)
	}

	getMissingRate = async (mainConversionAssets, assetTarget, typeConversion) => {
		let assetSoId = 'asset_' + assetTarget
		if (typeof mainConversionAssets != 'undefined'
			&& typeof mainConversionAssets[assetSoId] != 'undefined') {
			if (typeConversion === 'average') {
				// eslint-disable-next-line max-len
				return (parseFloat(mainConversionAssets[assetSoId].bid) + parseFloat(mainConversionAssets[assetSoId].ask)) / 2
			}
			if (typeConversion === 'bid') {
				return parseFloat(mainConversionAssets[assetSoId].bid)
			}
			if (typeConversion === 'ask') {
				return parseFloat(mainConversionAssets[assetSoId].ask)
			}
		}
		return 1
	}

	convertFromCurrencyToUserCurrency = async (fromCurrency, userCurrency) => {
		const {
			latestRatesDetailConvertFromCurrency,
			latestRatesDetailConvertUserCurrency,
			dispatch
		} = this.props
		let priceConvert = 1
		fromCurrency = fromCurrency.trim()
		userCurrency = userCurrency.trim().substring(0, 3)
		if (fromCurrency === userCurrency) {
			return new Decimal(priceConvert)
		}
		let detailConvertFromCurrency = converterTable[fromCurrency]
		let detailConvertUserCurrency = converterTable[userCurrency]
		if (fromCurrency !== 'USD' && typeof detailConvertFromCurrency != 'undefined') {
			// eslint-disable-next-line max-len
			if (latestRatesDetailConvertFromCurrency === undefined || latestRatesDetailConvertFromCurrency === 1) {   //sunday no rates
				this.getMissingRate(detailConvertFromCurrency['soId'], 'average').then((response) => {
					dispatch(setLatestRatesItem( {
						'assetSoId': 'asset_' + detailConvertFromCurrency['soId'],
						'rates': response
					}))
				})
			}
		}
		if (userCurrency !== 'USD') {
			// eslint-disable-next-line max-len
			if (latestRatesDetailConvertUserCurrency === undefined || latestRatesDetailConvertUserCurrency === 1) {   //sunday no rates
				this.getMissingRate(detailConvertUserCurrency['soId'], 'average').then((response) => {
					dispatch(setLatestRatesItem( {
						'assetSoId': 'asset_' + detailConvertUserCurrency['soId'],
						'rates': response
					}))
				})
			}
		}
		//convert logic
		if (fromCurrency !== 'USD' && typeof detailConvertFromCurrency != 'undefined') { //need to convert Twice
			if (detailConvertFromCurrency['inverse'] !== 0) {
				priceConvert = 1 / latestRatesDetailConvertFromCurrency // convert to usd
			} else {
				priceConvert = latestRatesDetailConvertFromCurrency // convert to usd
			}
			if (userCurrency !== 'USD') {
				if (detailConvertUserCurrency['inverse'] !== 0) {
					priceConvert = priceConvert * latestRatesDetailConvertUserCurrency // convert to usd
				} else {
					priceConvert = priceConvert / latestRatesDetailConvertUserCurrency // convert to usd
				}
			}
			return priceConvert !== undefined ? new Decimal(priceConvert) : new Decimal(1)
		}
		if (userCurrency !== 'USD') {
			//need to convert once
			if (detailConvertUserCurrency['inverse'] !== 0) {
				priceConvert = 1 * latestRatesDetailConvertUserCurrency
				return new Decimal(priceConvert)
			} else {
				priceConvert = 1 / latestRatesDetailConvertUserCurrency
				return new Decimal(priceConvert)
			}
		}
		return new Decimal(priceConvert.toPrecision(7))
	}

	marginUserCal =  async () => {
		const {
			assetType,
			complexLeverage,
			assetLotSize
		} = this.props
		let lotCount =  await this.getLotCountAsset()
		// eslint-disable-next-line max-len
		let complexLeverageValue = (typeof complexLeverage === 'undefined' || complexLeverage === null) ? 0.01 : complexLeverage[assetType]
		if(typeof localStorage.getItem('newUserData') != 'undefined' ){
			let newUserData = JSON.parse(localStorage.getItem('newUserData'))
			if(newUserData !== null && newUserData ) {
				// eslint-disable-next-line max-len
				complexLeverageValue = (typeof newUserData.complexLeverage === 'undefined' || newUserData.complexLeverage === null) ? complexLeverageValue : newUserData.complexLeverage[assetType]
				complexLeverageValue = parseFloat(complexLeverageValue)
			}
		}
		return new Decimal(assetLotSize).mul(lotCount).mul(complexLeverageValue)
	}

	fullCalculationMarginUsed = async (targetAssetName, loginUserCurrency, currentPrice) => {
		let priceConversion = await this.convertFromCurrencyToUserCurrency(targetAssetName, loginUserCurrency)
		let conversionRate = await this.marginUserCal()
		return priceConversion.mul(conversionRate).mul(new Decimal(currentPrice))
	}

	refreshPipValue = async () => {
		let lotCount
		let noneRateConvertPipValue
		const {
			assetLotSize,
			marginTrade,
			leverage,
			assetTargetForex,
			lastUsdPrice,
			pipDecimalPlaces,
			latestRatesAssetTargetForex,
			latestRatesAsset,
			mainConversionAssets,
			dispatch
		} = this.props

		try {
			let decimalNumber = await this.getDecimalNumber(pipDecimalPlaces)
			if (marginTrade) { //todo? marginTrade always 1
				lotCount = await this.getLotCountAsset()
			} else {
				lotCount = leverage
			}
			noneRateConvertPipValue = await this.pipValueDetailsWithOutConversion(
				new Decimal(assetLotSize),
				lotCount, decimalNumber
			)
		} catch (err) {
			// eslint-disable-next-line no-console
			console.log('refreshPipValue err', err)
		}
		let rateTarget = 1

		if (!(assetTargetForex === undefined)) {
			// sunday no rates
			if (latestRatesAssetTargetForex === undefined) {
				if (+assetTargetForex[0] !== -1) {
					this.getMissingRate(mainConversionAssets, assetTargetForex[0], 'bid').then((price) => {
						dispatch(setLatestRatesItem( {'assetSoId': 'asset_' + assetTargetForex[0], 'rates': price}))
					})
				}
			}
			// If we need to convert more than just USD
			if (+assetTargetForex[0] > -1) {
				// rateTarget<1 always
				rateTarget = ((+assetTargetForex[1] === 1)
					? 1 / latestRatesAssetTargetForex
					: latestRatesAssetTargetForex)
				rateTarget = new Decimal(((rateTarget === undefined) ? 0 : rateTarget))
			} else {
				rateTarget = ((+assetTargetForex[1] === 1) ? 1 : 1 / latestRatesAsset)
				rateTarget = new Decimal(((rateTarget === undefined) ? 0 : rateTarget))
			}
		}
		return (new Decimal(1 / lastUsdPrice)).mul(rateTarget).mul(noneRateConvertPipValue)
	}

	conversionCal = async () => {
		const {
			loginUserCurrency,
			latestRatesAssetSoId,
			soId,
			assetType,
			assetTitle
		} = this.props
		let currentPrice
		let currentLoginUserCurrency = loginUserCurrency
		if (!currentLoginUserCurrency) {
			currentLoginUserCurrency = 'USD'
		}
		currentLoginUserCurrency = currentLoginUserCurrency.trim()
		if (latestRatesAssetSoId === undefined) {
			currentPrice = await this.getMissingRate(soId, 'average')
		} else {
			currentPrice = latestRatesAssetSoId
		}

		let targetAssetName = getTargetAssetName(assetTitle, assetType)
		if (assetType === 'currencies') {
			currentPrice = 1 // no need to mul it with the asset price
		}
		return await this.fullCalculationMarginUsed(targetAssetName, currentLoginUserCurrency, currentPrice)
	}
}
